import React from 'react';
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import { useTranslation } from 'react-i18next';
import { messageService } from '../../../services/messageService';
import { useDispatch } from 'react-redux';
import { saveSMStateAttr } from '../../../reducers/standardMailReducer';

const CommandBarRight = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const newClick = () => {
    messageService.sendMessage({ isNewSM: true });
    dispatch(saveSMStateAttr('isClear', true));
    dispatch(saveSMStateAttr('formData', {}));
    // props.createNew(true);
  };
  const saveFormData = () => {
    messageService.sendMessage({ saveSMData: true });
  };
  const handleRemove = () => {
    // props.handleRemove();
  };

  const getItems = () => {
    return [
      {
        key: 'new',
        text: t('new'),
        iconProps: { iconName: 'Add' },
        onClick: () => {
          newClick();
        },
        disabled: false,
      },
      {
        key: 'save',
        text: t('save'),
        iconProps: { iconName: 'Save' },
        onClick: () => {
          saveFormData();
        },
        disabled: false,
      },
    ];
  };

  return (
    <div>
      <CommandBar
        items={getItems()}
        ariaLabel="Use left and right arrow keys to navigate between commands"
      />
    </div>
  );
};

export default CommandBarRight;
